export const paychexUserLinkTypes = {
  NONE: "NONE",
  PERKS: "PERKS",
  ROLLOVER: "ROLLOVER",
  ROLLOVER_THEN_PERKS: "ROLLOVER_THEN_PERKS",
  PERKS_THEN_ROLLOVER: "PERKS_THEN_ROLLOVER",
} as const;

export type PaychexUserLinkType =
  (typeof paychexUserLinkTypes)[keyof typeof paychexUserLinkTypes];

// Link types that carry a Perks link; ROLLOVER is 401(k) roll-in only.
export const perksUserLinkTypes: PaychexUserLinkType[] = [
  paychexUserLinkTypes.PERKS,
  paychexUserLinkTypes.ROLLOVER_THEN_PERKS,
  paychexUserLinkTypes.PERKS_THEN_ROLLOVER,
];

// Link types that carry a 401(k) roll-in.
export const rolloverUserLinkTypes: PaychexUserLinkType[] = [
  paychexUserLinkTypes.ROLLOVER,
  paychexUserLinkTypes.ROLLOVER_THEN_PERKS,
  paychexUserLinkTypes.PERKS_THEN_ROLLOVER,
];
